/**
 * Blank component
 * @param height 빈 영역 높이
 * @param margin 빈 영역 마진
 * @param color 빈 영역 색상
 */

import { Blank as BlankShared } from "@shared/src";

const Blank = ({
  height,
  margin = "",
  color = "transparent",
}: {
  height: number;
  margin?: string;
  color?: string;
}) => {
  return (
    // <div
    //   className="blank-wrap"
    //   style={{
    //     minWidth: "100%",
    //     height: height + "px",
    //     margin: margin,
    //     backgroundColor: color ? color : "transparent",
    //   }}
    // ></div>
    <BlankShared height={height} margin={margin} color={color} />
  );
};

export default Blank;
